import { fioLitleTruncateFromObject, fioFromObject } from "./strings";

export function getQueryParams(query) {
  if (!query || !Object.keys(query).length) {
    return {};
  }

  query.page = query.page ? query.page : 0;

  if (query.number && parseInt(query.number, 10) <= 0) {
    delete query.number;
  } else {
    query.number = parseInt(query.number, 10);
  }

  return query;
}

export function getStatusBlankString(status, toLowerCase = false) {
  // add, remove
  let returnString = "";

  switch (status) {
    case "type_add":
      returnString = "Приходный";
      break;
    case "type_remove":
      returnString = "Расходный";
      break;
    default:
      returnString = status;
      break;
  }

  if (toLowerCase) {
    returnString = returnString.toLowerCase();
  }

  return returnString;
}

export function getFioAddFromGiveToLittleTruncate(blank) {
  let returnFio = "";
  let typeField = "";

  if (blank.blank_type === "type_add") {
    typeField = "add_from";
  } else if (blank.blank_type === "type_remove") {
    typeField = "give_to";
  } else {
    return returnFio;
  }

  if (blank[typeField].user_type === "USER") {
    if (blank[typeField].user_id) {
      returnFio = fioLitleTruncateFromObject(blank[typeField].user_id);
    } else {
      returnFio = blank[typeField].user_fio;
    }
  } else if (blank[typeField].user_type === "DEPOSITOR") {
    returnFio = fioLitleTruncateFromObject(blank[typeField].depositor_id);
  } else {
    returnFio = blank[typeField].user_fio;
  }

  return returnFio;
}

export function getTypeBlank(blank) {
  const returnObject = {
    type: "",
    _id: "",
    isHaveId: false,
    fio: "",
    fioFull: ""
  };
  let typeField = "";
  let typeIdField = "";

  if (blank.blank_type === "type_add") {
    typeField = "add_from";
  } else if (blank.blank_type === "type_remove") {
    typeField = "give_to";
  }

  if (blank[typeField].user_type === "USER") {
    typeIdField = "user_id";
  } else if (blank[typeField].user_type === "DEPOSITOR") {
    typeIdField = "depositor_id";
  }

  // USER || DEPOSITOR => user || depositor
  returnObject.type = String(blank[typeField].user_type).toLowerCase();

  if (blank[typeField][typeIdField]) {
    returnObject.fio = fioLitleTruncateFromObject(
      blank[typeField][typeIdField]
    );
    returnObject.fioFull = fioFromObject(blank[typeField][typeIdField]);

    returnObject.isHaveId = true;
    returnObject._id = blank[typeField][typeIdField]._id;
  } else {
    returnObject.fio = blank[typeField].user_fio;
  }

  return returnObject;
}

export function getTitleAddOrGive(blank) {
  let title = "";
  let typeField = "";

  if (blank.blank_type === "type_add") {
    typeField = "add_from";
    title = "Принято от ";
  } else if (blank.blank_type === "type_remove") {
    typeField = "give_to";
    title = "Выдано ";
  } else {
    return title;
  }

  if (blank[typeField].user_type === "USER") {
    title += "пользовател" + (typeField === "add_from" ? "я" : "ю");
  } else if (blank[typeField].user_type === "DEPOSITOR") {
    title += "залогодател" + (typeField === "add_from" ? "я" : "ю");
  }

  return title;
}
